export default __webpack_public_path__ + "static/media/bowie54.49f2144e.webp";